export const ROLES = {
  CEO: 4,
  ADMIN: 3, // admin has more privliges than manager
  MANAGER: 2,
  SALES: 1,
}
